// extracted by mini-css-extract-plugin
module.exports = {"checkboxInput":"Checkbox_checkboxInput__18PC4","checkmark":"Checkbox_checkmark__2R_s9","checkboxWrapper":"Checkbox_checkboxWrapper__1tSGH"};